export const findDuplicatesInArray = (arr) => arr.filter(
  (currentValue, currentIndex) => arr.indexOf(currentValue) !== currentIndex,
);
